module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar hoverImage = (helpers.detectRenderedImage(model.hoverImage, model._hoverImage) || {}).rendered || {};\nvar url = 'none';\nif(hoverImage.url){\nurl = 'url(' + hoverImage.url + ')';\n}\n%>\n<div class=\"<%- model.isGroup ? 'isGroup ' : '' %><%- model.position.data %> <%- model.color.data %>\" style=\"background-image: <%- url %>;\">\n<div class=\"background\"></div>\n<div class=\"content\">\n<%\nif(model.isGroup){\n%>\n<%- helpers.renderSection(); %>\n<%\n} else if(model.headline){\n%>\n<h2><%= model.headline %></h2>\n<%\n}\n%>\n</div>\n</div>"
  , __filename = "components/templates/window/segment.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var hoverImage = (helpers.detectRenderedImage(model.hoverImage, model._hoverImage) || {}).rendered || {};
var url = 'none';
if(hoverImage.url){
url = 'url(' + hoverImage.url + ')';
}

    ; __line = 7
    ; __append("\n<div class=\"")
    ; __line = 8
    ; __append( model.isGroup ? 'isGroup ' : '' )
    ; __append( model.position.data )
    ; __append(" ")
    ; __append( model.color.data )
    ; __append("\" style=\"background-image: ")
    ; __append( url )
    ; __append(";\">\n<div class=\"background\"></div>\n<div class=\"content\">\n")
    ; __line = 11
    ; 
if(model.isGroup){

    ; __line = 13
    ; __append("\n")
    ; __line = 14
    ; __append( helpers.renderSection() )
    ; __append("\n")
    ; __line = 15
    ; 
} else if(model.headline){

    ; __line = 17
    ; __append("\n<h2>")
    ; __line = 18
    ; __append(escapeFn( model.headline ))
    ; __append("</h2>\n")
    ; __line = 19
    ; 
}

    ; __line = 21
    ; __append("\n</div>\n</div>")
    ; __line = 23
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/window/segment.ejs

}